import { useQuery } from "react-query";
import { getPhotos } from "../../../components/image-editing/lib/imageData";

export const usePhotos = (wipKey) => {
    return useQuery({
        queryKey: ["photos", wipKey],
        queryFn: async () => getPhotos(wipKey),
        staleTime: 1000,
    });
};
